import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  CircularProgress
} from '@mui/material';

const InactivateEmailDialog = ({ onConfirm, mylist, handleClose }) => {
  const [selectedStatus, setSelectedStatus] = useState(mylist?.status === 'Active' ? 'Inactive' : 'Active');
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    await onConfirm(selectedStatus);
    setLoading(false);
    handleClose();
  };

  return (
    <Dialog
      open={true}
      // onClose={handleClose}
      PaperProps={{
        sx: {
          borderRadius: '1rem',
          padding: '0.5rem',
          maxWidth: '28rem',
          width: '90%'
        }
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>
        Update Agent Status
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2, textAlign: 'center' }}>
         Are you sure you want to Inactive this agent
          <strong> {mylist?.email}</strong> ?
        </DialogContentText>
        {/* <DialogContentText sx={{ mb: 2, textAlign: 'center' }}>
          <strong>Day:</strong> {mylist?.day}
        </DialogContentText>
        <DialogContentText sx={{ mb: 3, textAlign: 'center' }}>
          <strong>Time Slot:</strong> {mylist?.time}
        </DialogContentText> */}
        
        {/* <FormControl component="fieldset" sx={{ width: '100%' }}>
          <FormLabel component="legend" sx={{ textAlign: 'center', width: '100%', mb: 2 }}>
            Select New Status
          </FormLabel>
          <RadioGroup
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            sx={{ alignItems: 'center' }}
          >
            <FormControlLabel 
              value="Active" 
              control={<Radio sx={{ color: '#4caf50', '&.Mui-checked': { color: '#4caf50' } }} />} 
              label="Active" 
            />
            <FormControlLabel 
              value="Inactive" 
              control={<Radio sx={{ color: '#f44336', '&.Mui-checked': { color: '#f44336' } }} />} 
              label="Inactive" 
            />
          </RadioGroup>
        </FormControl> */}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 2 }}>
        <Button
          onClick={handleClose}
          variant="outlined"
          sx={{
            borderRadius: '2rem',
            padding: '0.5rem 1.5rem',
            textTransform: 'none'
          }}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          sx={{
            borderRadius: '2rem',
            padding: '0.5rem 1.5rem',
            textTransform: 'none',
            backgroundColor: selectedStatus === 'Active' ? '#4caf50' : '#f44336',
            '&:hover': {
              backgroundColor: selectedStatus === 'Active' ? '#45a049' : '#d32f2f'
            }
          }}
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} /> : `Update to ${selectedStatus}`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InactivateEmailDialog;